<form [formGroup]="formGroup">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row g-3 mb-2">
            <div
              class="col-xs-12 col-sm-12 col-md-3 col-xl-8 input-trend-search mb-1"
            >
              <input
                type="search"
                #searchBox
                class="form-control"
                [placeholder]="'contact.contactList.searchPlaceholder' | translate"
                [value]="searchString ?? ''"
                (keyup)="search(searchBox.value)"
              />
              <span class="mdi mdi-magnify search-icon ml-2"></span>
            </div>
            @if (showAddContactButton) {
            <div
              class="col-xs-12 col-sm-12 col-md-3 col-xl-2 btn-group trend-button"
            >
              <button class="btn btn-info fw-bold" (click)="add()">
                {{ 'contact.contactList.add' | translate }}
              </button>
            </div>
            } @if (isAdmin() && showImportContactButton) {
            <div
              class="col-xs-12 col-sm-12 col-md-3 col-xl-1 btn-group trend-button"
            >
              <button
                class="btn btn-primary fw-bold"
                (click)="import()"
                [matTooltip]="'contact.contactList.importTooltip' | translate"
              >
                <i class="mdi mdi-file-import"></i>
              </button>
            </div>
            } @if (isAdmin()) {
            <div
              class="col-xs-12 col-sm-12 col-md-3 col-xl-1 btn-group trend-button"
            >
                <button
                class="btn btn-primary fw-bold"
                (click)="exportContacts()"
                [matTooltip]="'contact.contactList.exportTooltip' | translate"
                [disabled]="loading"
              >
              @if(loading) {
                <i class="mdi mdi-loading mdi-spin"></i>
              } @else {
                <i class="ri-file-text-line"></i>
              }
              </button>
            </div>
            } @if (showActionCustomerPortfolioButtons) {
            <div
              class="col-xs-12 col-sm-12 col-md-3 col-xl-1 btn-group trend-button"
            >
              <button
                class="btn btn-primary fw-bold"
                (click)="transferCustomerPortfolioList()"
                [matTooltip]="'contact.contactList.transferPortfolioTooltip' | translate"
              >
                <i class="mdi mdi-transfer"></i>
              </button>
            </div>

            <div
              class="col-xs-12 col-sm-12 col-md-3 col-xl-1 btn-group trend-button"
            >
              <button
                class="btn btn-primary fw-bold"
                (click)="removeFromCustomerPortfolioList()"
                [matTooltip]="'contact.contactList.removePortfolioTooltip' | translate"
              >
                <i class="mdi mdi-delete"></i>
              </button>
            </div>
            }

            <mat-menu #tagMenu="matMenu" class="custom-menu-panel">
              <div class="col-12 input-trend-search p-2">
                <input
                  class="form-control"
                  type="text"
                  (focus)="onFocusTags()"
                  [formControl]="filterControlTags"
                  (click)="$event.stopPropagation()"
                  [placeholder]="'contact.contactList.searchTagPlaceholder' | translate"
                />
                <span class="mdi mdi-magnify search-icon mt-2"></span>
              </div>
              @if (allTags.length > 0) { @for (tag of allTags; track $index) {
              <div
                class="form-check form-checkbox-info m-1"
                (click)="$event.stopPropagation()"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  (click)="$event.stopPropagation()"
                  (change)="selectTag($event, tag._id)"
                  [value]="tag._id"
                  [checked]="formGroup.get('tags').value.includes(tag._id)"
                  id="tag{{ tag._id }}"
                />
                <label
                  class="form-check-label ms-1"
                  for="tag{{ tag._id }}"
                  (click)="$event.stopPropagation()"
                  >{{ tag.title }}</label
                >
              </div>
              } } @else {
              <span class="text-muted m-1">{{ 'contact.contactList.noTagFound' | translate }}</span>
              }
            </mat-menu>

            <mat-menu #channelMenu="matMenu">
              @if (listChannel.length > 0) {
              <button mat-menu-item (click)="searchByChannel(null)">
                {{ 'contact.contactList.all' | translate }}
              </button>
              @for (channel of listChannel; track $index) {
              <button mat-menu-item (click)="searchByChannel(channel)">
                {{ channel.name }}
              </button>
              } } @else {
              <h6 class="text-muted m-1">{{ 'contact.contactList.noResultsFound' | translate }}</h6>
              }
            </mat-menu>

            <mat-menu #blockedMenu="matMenu">
              <button mat-menu-item (click)="searchByBlocked(null)">
                {{ 'contact.contactList.all' | translate }}
              </button>
              <button mat-menu-item (click)="searchByBlocked('true')">
                {{ 'contact.contactList.blockedOnly' | translate }}
              </button>
              <button mat-menu-item (click)="searchByBlocked('false')">
                {{ 'contact.contactList.notBlockedOnly' | translate }}
              </button>
            </mat-menu>
          </div>
          <div class="row g-3 align-items-center">
            <div class="col-xs-12 col-sm-12 col-md-3 trend-datepicker">
              <mat-date-range-input
                [rangePicker]="picker"
                formGroupName="dateRange"
              >
                <input
                  matStartDate
                  [placeholder]="'contact.contactList.startDate' | translate"
                  formControlName="dateStart"
                />
                <input
                  matEndDate
                  [placeholder]="'contact.contactList.endDate' | translate"
                  formControlName="dateEnd"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker" />
              <mat-date-range-picker #picker>
                <mat-datepicker-actions>
                  <mat-select
                    class="input-field rounded-lg"
                    (selectionChange)="onPeriodChange($event)"
                    [placeholder]="'contact.contactList.select' | translate"
                  >
                    <mat-option value="1">{{ 'contact.contactList.today' | translate }}</mat-option>
                    <mat-option value="7">{{ 'contact.contactList.last7Days' | translate }}</mat-option>
                    <mat-option value="15">{{ 'contact.contactList.last15Days' | translate }}</mat-option>
                    <mat-option value="30">{{ 'contact.contactList.last30Days' | translate }}</mat-option>
                    <mat-option value="60">{{ 'contact.contactList.last60Days' | translate }}</mat-option>
                  </mat-select>
                  <button mat-raised-button matDatepickerApply class="btnOk">
                    OK
                  </button>
                </mat-datepicker-actions>
              </mat-date-range-picker>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-3 btn-group trend-button">
              <button
                [matMenuTriggerFor]="tagMenu"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant d-block dropdown-toggle"
              >
                <span>
                  {{ "Tags" }}
                </span>
              </button>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-3 btn-group trend-button">
              <button
                [matMenuTriggerFor]="channelMenu"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>
                  {{ labelChannel | translate }}
                </span>
              </button>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-3 btn-group trend-button">
              <button
                [matMenuTriggerFor]="blockedMenu"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>
                  {{ labelBlocked | translate }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

@if(showCards) {
<div class="row mb-3 g-3">
  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
    <div
      class="card-hover"
      [ngClass]="{
        'border-primary border border-primary-subtle': selectedCard === ''
      }"
    >
      <card-graphic-small-component
        [label]="'contact.list.summaryTotal' | translate"
        [total]="$safeNavigationMigration(totalContact?.toString())"
        [totalContact]="pager.list.length"
        (click)="clearSearchByValid()"
      />
    </div>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
    <div
      class="card-hover"
      [ngClass]="{
        'border-primary border border-primary-subtle':
          selectedCard === 'VALIDATED'
      }"
    >
      <card-graphic-small-component
        [label]="'contact.list.summaryValidated' | translate"
        [total]="$safeNavigationMigration(totalContactValidated?.toString())"
        [totalContact]="totalContact"
        [selectable]="true"
        [selected]="selectedCard === 'VALIDATED'"
        (click)="searchByValid('VALIDATED')"
      />
    </div>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
    <div
      class="card-hover"
      [ngClass]="{
        'border-primary border border-primary-subtle':
          selectedCard === 'NOT_VALIDATED'
      }"
    >
      <card-graphic-small-component
        [label]="'contact.list.summaryNotValidated' | translate"
        [total]="$safeNavigationMigration(totalContactNotValidated?.toString())"
        [totalContact]="totalContact"
        [selectable]="true"
        [selected]="selectedCard === 'NOT_VALIDATED'"
        (click)="searchByValid('NOT_VALIDATED')"
      />
    </div>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
    <div
      class="card-hover"
      [ngClass]="{
        'border-primary border border-primary-subtle':
          selectedCard === 'INVALID'
      }"
    >
      <card-graphic-small-component
        [label]="'contact.list.summaryInvalid' | translate"
        [total]="$safeNavigationMigration(totalContactInvalid?.toString())"
        [totalContact]="totalContact"
        [selectable]="true"
        [selected]="selectedCard === 'INVALID'"
        (click)="searchByValid('INVALID')"
      />
    </div>
  </div>
</div>
} @if(loadingContent) {
<content-loading-list />
} @if(pager.total === 0 && !loadingContent) {
<empty-records-component
  [message]="'contact.list.emptyMessage' | translate"
  [icon]="'mdi mdi-account-alert'"
  [subMessage]="'contact.list.emptySubMessage' | translate"
  [buttonClass]="'btn btn-info fw-bold'"
  [labelButton]="'contact.list.emptyAddButton' | translate"
  (emitEvent)="add()"
/>
} @if(toggleTableCard) { @if (!loadingContent && pager.total > 0) {
<div class="row g-3 align-items-stretch mb-3">
  @for(item of pager.list; track item) {
  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
    <div
      class="card-button-hover h-100"
      (click)="view(item)"
      style="cursor: pointer"
    >
      <div class="card h-100 shadow-sm">
        <div class="p-2">
          <div class="d-flex align-items-center border-bottom py-1">
            <div class="avatar me-2 rounded-circle">
              <img
                [src]="getContactImage(item)"
                alt="{{ item?.name }}"
                class="img-fluid avatar-sm rounded-circle"
                (error)="onImageError($event)"
              />
            </div>
            <div class="flex-grow-1">
              <div class="d-flex align-items-center g-2 flex-wrap">
                <h6
                  class="mb-0 fw-bold"
                  [matTooltip]="item?.name?.length > 10 ? $safeNavigationMigration(item?.name) : null"
                >
                  {{ $safeNavigationMigration(item?.name) | truncate : 10 }}
                </h6>
              </div>
              <small>
                {{
                  item.createdAt
                    | timezoneDate
                      : "DD/MM/YYYY"
                      : getTimezoneCompanyCurrentUser()
                }}
              </small>
            </div>
            <div class="d-flex flex-column align-items-end gap-1">
              <span
                class="badge text-capitalize font-14"
                [ngClass]="{
                  'bg-success': item?.valid === 'VALIDATED',
                  'bg-warning': item?.valid === 'NOT_VALIDATED',
                  'bg-danger': item?.valid === 'INVALID'
                }"
              >
                {{ getContactStatus($safeNavigationMigration(item?.valid)) }}
              </span>
              @if (isBlocked(item)) {
              <span
                class="badge bg-secondary text-capitalize font-14"
                [matTooltip]="getBlockedChannelsTooltip(item)"
              >
                {{ 'contact.contactList.blockedBadge' | translate }}
              </span>
              }

              <!-- Same markings as the table row (RF-37). -->
            </div>
          </div>
          <div class="mt-2">
            <ul class="list-unstyled mb-0 small lead-list g-2">
              <li class="mb-2">
                <span class="d-flex flex-column mb-0 justify-content-start">
                  <span class="text-dark">{{ 'contact.contactList.phoneLabel' | translate }}</span>
                  <strong class="text-muted fw-light">
                    {{
                      (isAttendant() && !currentUser?.clientVisibilitys) ||
                      (!isAttendant() && (isSupervisor() || isAdmin()))
                        ? item.phone
                        : "-"
                    }}
                  </strong>
                </span>
              </li>
              <li class="mb-2">
                <span class="d-flex flex-column mb-0 justify-content-start">
                  <span class="text-dark">{{ 'contact.contactList.channelLabel' | translate }}</span>
                  <strong class="text-muted fw-light">
                    {{ getChannelContact(item._id) }}
                  </strong>
                </span>
              </li>
              <li class="mb-2">
                <span class="d-flex flex-column mb-0 justify-content-start">
                  <span class="text-dark">{{ 'contact.contactList.tagsLabel' | translate }}</span>
                  @if(item.tags.length > 0) {
                  <strong
                    class="text-muted fw-light"
                    [matTooltip]="getTagTitle(item).tooltip"
                  >
                    {{ getTagTitle(item).display ?? "-" }}
                  </strong>
                  } @else {
                  <strong class="text-muted fw-light">-</strong>
                  }
                </span>
              </li>
              <li class="mb-2">
                <span class="d-flex flex-column mb-0 justify-content-start">
                  <span class="text-dark">{{ 'contact.contactList.attendancesLabel' | translate }}</span>
                  <strong class="text-muted fw-light">
                    {{ getCountAttendades(item._id) }}
                  </strong>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
} } @else { @if(!loadingContent && pager.total > 0){
<div class="card">
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-hover table-centered mb-0">
        <thead>
          <tr>
            <th>
              @if(showActionCustomerPortfolioButtons) {
              <div class="form-checkbox-info form-radio-info">
                <input
                  type="checkbox"
                  class="form-check-input rounded-circle"
                  [(ngModel)]="selectAll"
                  (change)="selectDeselectAll()"
                  (click)="$event.stopPropagation()"
                />
              </div>
              }
            </th>
            <th class="text-primary-emphasis">{{ 'contact.contactList.name' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'contact.contactList.createdAt' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'contact.contactList.status' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'contact.contactList.phone' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'contact.contactList.channel' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'contact.contactList.tags' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'contact.contactList.origin' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'contact.contactList.attendances' | translate }}</th>
            @if(showActionCustomerPortfolioButtons) {
            <th class="sr-only"></th>
            }
          </tr>
        </thead>
        <tbody>
          @for (item of pager.list; track $index) {
          <tr (click)="view(item)" style="cursor: pointer">
            <td>
              @if(showActionCustomerPortfolioButtons) {
              <div class="form-checkbox-info mb-2">
                <input
                  type="checkbox"
                  class="form-check-input rounded-circle"
                  [checked]="selectedContactsIds.includes(item._id)"
                  (change)="changeSelectContact(item._id)"
                  (click)="$event.stopPropagation()"
                />
              </div>
              }
            </td>
            <td>
              <p [matTooltip]="item.name">
                {{ $safeNavigationMigration(item?.name) | truncate : 20 }}
              </p>
            </td>
            <td>
              <p>
                {{ item.createdAt | date : "dd/MM/yyyy" }}
              </p>
            </td>
            <td>
              <div class="d-flex flex-wrap gap-1">
                <span
                  class="badge text-capitalize font-14"
                  [ngClass]="{
                    'bg-success': item?.valid === 'VALIDATED',
                    'bg-warning': item?.valid === 'NOT_VALIDATED',
                    'bg-danger': item?.valid === 'INVALID'
                  }"
                >
                  {{ getContactStatus($safeNavigationMigration(item?.valid)) }}
                </span>
                @if (isBlocked(item)) {
                <span
                  class="badge bg-secondary text-capitalize font-14"
                  [matTooltip]="getBlockedChannelsTooltip(item)"
                >
                  {{ 'contact.contactList.blockedBadge' | translate }}
                </span>
                }

                <!--
                  Manual lead markings (RF-37). Shown to everyone, set by few: a
                  marking that changes what the whole team sees on the board must
                  be visible to the person looking at the lead, even when they
                  cannot change it.
                -->
              </div>
            </td>
            <td>
              <p>
                {{
                  (isAttendant() && !currentUser?.clientVisibilitys) ||
                  (!isAttendant() && (isSupervisor() || isAdmin()))
                    ? item.phone
                    : "-"
                }}
              </p>
            </td>
            <td>
              <p [matTooltip]="getChannelContact(item._id)">
                {{ getChannelContact(item._id) | truncate : 15 }}
              </p>
            </td>
            <td>
              <p [matTooltip]="getTagTitle(item).tooltip">
                {{ getTagTitle(item).display ?? "-" }}
              </p>
            </td>
            <td>
              <p>
                {{ item?.leadSource?.name ? item?.leadSource?.name : '-' }}
              </p>
            </td>
            <td>
              <p>
                {{ getCountAttendades(item._id) }}
              </p>
            </td>
            @if(showActionCustomerPortfolioButtons) {
            <td>
              <div class="d-flex justify-content-end">
                <button
                  class="btn btn-dropdown-list"
                  [matMenuTriggerFor]="menu"
                  type="button"
                  (click)="$event.stopPropagation()"
                  (mousedown)="$event.stopPropagation()"
                >
                  <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
                </button>

                <mat-menu #menu="matMenu">
                  <button
                    mat-menu-item
                    tabindex="0"
                    (click)="
                      transferCustomerPortfolio(item); $event.stopPropagation()
                    "
                  >
                    {{ 'contact.contactList.transferPortfolioMenu' | translate }}
                  </button>

                  <button
                    mat-menu-item
                    tabindex="0"
                    (click)="
                      removeFromCustomerPortfolio(item);
                      $event.stopPropagation()
                    "
                  >
                    {{ 'contact.contactList.removePortfolioMenu' | translate }}
                  </button>

                  <!--
                    The lead markings moved to the CUSTOMERS list on 2026-08-21: marking
                    a lead is enrichment, and enrichment belongs to its CRM record.
                  -->
                </mat-menu>
              </div>
            </td>
            }
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
} } @if (pager.total > pager.perPage) {
<paginator [pager]="pager" (onPager)="loadPage($event)" />
}
